import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { "element-loading-text": "正在加载数据，请稍候" }
const _hoisted_2 = { class: "flex-contants" }
const _hoisted_3 = { style: {"text-align":"center"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 提 交 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 取 消 ")

import { reactive, ref, unref } from 'vue';
import { FormRules, ElForm, ElMessage, ElMessageBox } from 'element-plus';
import { useDictionary } from '@/store/dictionary.store';
import { CtAgreeApi } from '@/apis/contract/contract.api';
import { GetStampDetailApi, GetStampDpListApi } from '@/apis/basics/stamps.api';
import { string } from 'vue-types';


export default /*#__PURE__*/_defineComponent({
  emits: ['refresh'],
  setup(__props, { expose, emit: $emits }) {

const { getName } = useDictionary();


const elFormRef = ref<ComponentRef<typeof ElForm>>();

const state = reactive({
	show: false,
	loading: false,
	detail: {} as any,
	stampList: [] as any[],
	rules: {
		stamp_id: [{ required: true, message: '请选择合同用印', trigger: 'blur' }],
		file_total: [{ required: true, message: '请输入用印文件梳理', trigger: 'blur' }],
	} as FormRules,
	selectedStamp: {} as any,
});

const schema = ref<any>({
	id: '',
	revision: '',
	stamp_id: '',
	file_total: 1,
	remark: '',
});

const load = {
	/* 获取下拉列表 */
	getStampDropdownList: async (mainstayId: string) => {
		const { succeeded, data } = await GetStampDpListApi({ mainstay_id: mainstayId, current: 1, page_size: 99 });
		state.stampList = succeeded ? data || [] : [];
		state.selectedStamp={};
	},
};

const actions = {
	/* 审批通过 */
	save: () => {
		unref(elFormRef)?.validate(async (isValid: boolean) => {
			if (!isValid) return;

			state.loading = true;

			const formData = unref(schema);
			const { succeeded, errors } = await CtAgreeApi(formData);

			if (!succeeded) {
				ElMessage.error(errors);
			} else {
				ElMessage.success('提交审批成功。');

				$emits('refresh', succeeded);
				state.show = false;
			}

			state.loading = false;
		});
	},
	selectStamp: async (stampid:string) =>{
		const { succeeded, data } = await GetStampDetailApi(stampid);
		state.selectedStamp = data;
	}
};

/* 打开对话框 */
const showDialog = async (contract: any) => {
	schema.value = {
		id: contract.contract_id,
		revision: contract.revision,
		file_total: 2,
	};

	await load.getStampDropdownList(contract.mainstay_id);

	/* 如果没有印章，则提示消息 */
	if ((state.stampList ?? []).length > 0) {
		state.detail = contract;
		state.show = true;
	} else {
		const msg = `该公司未设置印章管理人员，将无法进行申请用印。若需要用印，请联系管理员设置印章。`;
		ElMessageBox({ type: 'warning', lockScroll: false, title: '警告！', message: msg, buttonSize: 'small' });
	}
};

expose({ showDialog });

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "用印申请",
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(state).show) = $event)),
    width: "580"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          disabled: _unref(state).loading,
          onClick: actions.save
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_el_button, {
          size: "small",
          type: "info",
          disabled: _unref(state).loading,
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(state).show = false))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(ElForm), {
          ref_key: "elFormRef",
          ref: elFormRef,
          model: schema.value,
          "label-position": "top",
          rules: _unref(state).rules,
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "合同编号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).detail.contract_no,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).detail.contract_no) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "合同名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).detail.contract_name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).detail.contract_name) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "印章",
                  prop: "stamp_id"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: schema.value.stamp_id,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((schema.value.stamp_id) = $event)),
                      style: {"width":"100%"},
                      placeholder: "请选择本次合同用印",
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (actions.selectStamp(schema.value.stamp_id)))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).stampList, (stamp) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: stamp.id,
                            label: stamp.stamp_name,
                            value: stamp.id
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", null, _toDisplayString(`${stamp.stamp_name}(${stamp.stamp_no})`), 1),
                                _createElementVNode("div", null, _toDisplayString(_unref(getName)('stamp_type', stamp.stamp_type)), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (schema.value.stamp_id !== undefined)
              ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 0,
                  span: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { style: {"margin-left":"10px","margin-top":"0px"} }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString('印章管理人员：'+`${_unref(state).selectedStamp.managers_name}`) + " " + _toDisplayString('电话：'+`${_unref(state).selectedStamp.managers_mb}`), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { style: {"margin-left":"10px"} }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString('主体：'+`${_unref(state).selectedStamp.mainstay_name}`), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { style: {"margin-left":"10px"} }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString('备注：'+`${_unref(state).selectedStamp.remark}`), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "用印文件数量(一式N份)",
                  prop: "file_total"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      style: {"width":"100%"},
                      modelValue: schema.value.file_total,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((schema.value.file_total) = $event)),
                      min: 1,
                      max: 10,
                      placeholder: "用印文件数量(一式N份)"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "申请备注",
                  prop: "remark"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: schema.value.remark,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((schema.value.remark) = $event)),
                      type: "textarea",
                      "show-word-limit": "",
                      rows: "6",
                      maxlength: "150",
                      placeholder: "用印申请备注"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})